import Spacer from "@components/Spacer";
import { ITEM_HEIGHT_ARRAY } from "@features/product/product-item";
import { roundness } from "@provider/dripsy";
import { View } from "dripsy";
import * as React from "react";

const SHIMMER_INNER_HEIGHT_ARRAY = [90 - 24, 100 - 24, 130 - 24];
export function ProductShimmer() {
  return (
    <View
      sx={{
        height: ITEM_HEIGHT_ARRAY,
        backgroundColor: "$lightGrey",
        borderRadius: roundness,
        justifyContent: "space-between",
        padding: "$2",
        mx: "$2",
        my: "$1",
        opacity: 0.5,
        flexDirection: "row",
      }}
    >
      <View sx={{ flexDirection: "row" }}>
        <View
          sx={{
            backgroundColor: "$grey",
            height: "100%",
            width: SHIMMER_INNER_HEIGHT_ARRAY,
            borderRadius: roundness,
          }}
        />
        <View sx={{ ml: "$2", justifyContent: "space-between" }}>
          <View>
            <View
              sx={{
                backgroundColor: "$grey",
                height: [15, 20],
                width: 100,
                borderRadius: roundness,
              }}
            />
            <Spacer size="$1" />
            <View
              sx={{
                backgroundColor: "$grey",
                height: [15, 20],
                width: 80,
                borderRadius: roundness,
              }}
            />
          </View>
          <View
            sx={{
              backgroundColor: "$grey",
              height: [20, 25],
              width: 60,
              borderRadius: roundness,
            }}
          />
        </View>
      </View>
      <View sx={{ alignItems: "flex-end", justifyContent: "flex-end" }}>
        <View
          sx={{
            backgroundColor: "$grey",
            height: [25, 30],
            width: 50,
            borderRadius: roundness,
          }}
        />
        <Spacer size="$1" />
        <View
          sx={{
            backgroundColor: "$grey",
            height: [25, 30],
            width: 100,
            borderRadius: roundness,
          }}
        />
      </View>
    </View>
  );
}
